import React from "react";
import { Link } from "react-router-dom";
import PublicPage from "@/components/public/PublicPage";
import { APP_STORE_URL, GOOGLE_PLAY_URL } from "@/lib/app-links";
import { Apple, Play } from "lucide-react";
import { COMPLIANCE_DISCLAIMER } from "@/lib/compliance-copy";

const links = [
  { to: "/platform", title: "Platform overview", desc: "What the web dashboard and the mobile app each do." },
  { to: "/regional-compliance", title: "Regional compliance", desc: "How region selection and law packs work." },
  { to: "/multi-location", title: "Multi-location management", desc: "Running several sites from one dashboard." },
  { to: "/pricing", title: "Pricing", desc: "Per-unit monthly and annual pricing." },
  { to: "/privacy-policy", title: "Privacy policy", desc: "What we store and why." },
  { to: "/terms-of-service", title: "Terms of service", desc: "The agreement covering use of the platform." },
];

export default function Resources() {
  return (
    <PublicPage
      eyebrow="Resources"
      title="Resources and support"
      intro="Everything you need to understand how Crystal HACCP works before and after you sign up."
    >
      <section className="relative">
        <div className="max-w-6xl mx-auto px-4 py-10">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {links.map((l) => (
              <Link key={l.to} to={l.to} className="app-card p-5 block hover:border-crystal-orange/40 transition">
                <div className="text-white font-semibold">{l.title}</div>
                <p className="text-white/65 text-sm mt-1.5">{l.desc}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="relative">
        <div className="max-w-6xl mx-auto px-4 pb-20 space-y-4">
          <div className="app-card p-6">
            <div className="text-white font-semibold mb-1">Get the mobile app</div>
            <p className="text-white/65 text-sm mb-4">Available now on iPhone, iPad and Android.</p>
            <div className="flex flex-wrap gap-3">
              <a href={APP_STORE_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold cta-primary"><Apple size={16} /> App Store</a>
              <a href={GOOGLE_PLAY_URL} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold cta-primary"><Play size={16} /> Google Play</a>
            </div>
          </div>
          <div className="app-card p-6">
            <div className="text-white font-semibold mb-1">Talk to us</div>
            <p className="text-white/65 text-sm">
              Email{" "}
              <a href="mailto:info@crystalhaccp.com" className="text-crystal-orange hover:text-white">
                info@crystalhaccp.com
              </a>
              . One address, read by the founder.
            </p>
          </div>
          <p className="text-white/50 text-xs leading-relaxed">{COMPLIANCE_DISCLAIMER}</p>
        </div>
      </section>
    </PublicPage>
  );
}
